// Centralized API configuration
export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_URL || 'https://api.your-domain.com',
  
  // Fallback for development - works both locally and in containers
  get DEV_FALLBACK() {
    if (process.env.NODE_ENV === 'development') {
      // Check if we're running in a container (Docker networking)
      // In Docker, services communicate via service names, not localhost
      if (process.env.REACT_APP_DOCKER_ENV === 'true') {
        return 'http://backend:5001';
      }
      return 'http://localhost:5001';
    }
    return this.BASE_URL;
  },
  
  // Primary API URL to use throughout the app
  get URL() {
    return process.env.REACT_APP_API_URL || this.DEV_FALLBACK;
  }
} as const;